function AboutOne({ item }) {
    return (
        <div className='px-4 flex flex-col gap-1'>
            <img className='w-full h-auto' src={item.item.imageLink} alt={item.item.altText} />

            <div className="flex flex-col gap-1 font-medium">
                <h1 className='text-[20px] leading-7 text-[#FFFFFF]'>{item.item.Heading}</h1>

                <p className='text-[14px] leading-[26px] text-[#B0B0B0]'>{item.item.Description}</p>
            </div>
        </div>
    );
}

export default AboutOne;
